"use client"

import type { ReactNode } from "react"
import { useState, useEffect } from "react"
import { useAuth } from "@/components/auth-provider"
import { authClient } from "@/lib/auth"
import { get, post } from "@/lib/api"
import { getDeviceId } from "@new-cti/frontend-shared/auth/device-id"
import { useSessionGuard } from "@new-cti/frontend-shared/auth/hooks"
import { SessionLockOverlay } from "@new-cti/frontend-shared/auth/session-lock-overlay"
import { SESSION_APP } from "@new-cti/frontend-shared/auth/session-api"

// このアプリの api クライアント（get/post のみ必要）。安定参照にするためモジュールスコープに置く。
const sessionApi = { get, post }

/**
 * 複数端末同時ログインの締め出しゲート（staff）。
 *
 * 排他はアプリ単位(staff)。同一アカウントでも driver スマホのログインでは staff PC は締め出されない
 * （事務所PCのstaffセッションを維持するための業務要件）。別のstaff端末が後からログインした時のみロックする。
 */
export function SessionGuardGate({ children }: { children: ReactNode }) {
  const { isLoggedIn, logout } = useAuth()
  const [deviceId, setDeviceId] = useState("")
  useEffect(() => {
    setDeviceId(getDeviceId())
  }, [])

  const locked = useSessionGuard(authClient, sessionApi, SESSION_APP.staff, deviceId, isLoggedIn && !!deviceId)

  return (
    <>
      {children}
      {locked && <SessionLockOverlay onRelogin={() => { void logout() }} />}
    </>
  )
}
